
  
// Script Généré le : 10/01/2026 10:38:10 via ModelGenerator.nt
//  PafxFinancesFilters.ts
// Chemin de sortie : ..\..\..\front-shared\paf-shared\projects\ngx-paf-common\src\lib\Models\PafxFinancesFilters.ts

export class PafxFinancesFilters {

  // string MmDe
  public MmDe?: string=null;

  // string AaaaDe
  public AaaaDe?: string=null;

  // string MmA
  public MmA?: string=null;

  // string AaaaA
  public AaaaA?: string=null;

  // string[] PolCods
  public PolCods: string[]=[];

  // string[] RegCods
  public RegCods: string[]=[];

  // string[] SocCods
  public SocCods: string[]=[];

  // string[] EtbCods
  public EtbCods: string[]=[];

  // string[] Families
  public Families: string[]=[];

  // string[] SubTyps
  public SubTyps: string[]=[];

  // string[] SubTyp2s
  public SubTyp2s: string[]=[];

  // string TieCod
  public TieCod?: string=null;

  // string Groupe
  public Groupe?: string=null;

  // string FacCdeCta
  public FacCdeCta?: string=null;

  // string LngCod
  public LngCod?: string=null;

  // string Presentation
  public Presentation?: string=null;
}